import { ModelBase } from '../../core/model/model-base';
import { MoneyOptional } from '../../core/model/money';
import { Coding } from './coding';

export class InvoiceRow extends ModelBase {
  constructor(source: InvoiceRow) {
    super();
    if (!source) return;

    this.id = source.id;
    this.articleId = source.articleId;
    this.articleCode = source.articleCode;
    this.description = source.description;
    this.leaseAgreementNumber = source.leaseAgreementNumber;
    this.caption = source.caption;
    this.code = source.code;
    this.invoiceId = source.invoiceId;
    this.isInformation = source.isInformation;
    this.isRounding = source.isRounding;
    this.coding = source.coding;

    if (source.isInformation) {
      this.amount = new MoneyOptional();
      this.vatAmount = new MoneyOptional();
      this.amountIncludingVat = new MoneyOptional();
    } else {
      this.amount = new MoneyOptional(source.amount);
      this.vatAmount = new MoneyOptional(source.vatAmount);
      this.amountIncludingVat = new MoneyOptional(source.amountIncludingVat);
    }
  }

  amount: MoneyOptional;
  amountIncludingVat: MoneyOptional;
  articleId: string;
  articleCode: string;
  description: string;
  vatAmount: MoneyOptional;
  leaseAgreementNumber: string;
  caption: string;
  code: string;
  invoiceId: string;
  isInformation: boolean;
  isRounding: boolean;
  coding: Coding;

  get codingCostBearer(): string {
    return this.coding?.costBearer;
  }

  get codingCostPlace(): string {
    return this.coding?.costPlace;
  }

  get codingCounterpart(): string {
    return this.coding?.counterpart;
  }

  get codingProject(): string {
    return this.coding?.project;
  }

  get codingFunction(): string {
    return this.coding?.function;
  }

  toString() {
    return this.description ?? '';
  }
}
